// Global helper for opening delete modal
export function openDeleteModal(inloopId, inloopName) {
  console.log("Opening delete modal", { inloopId, inloopName })

  const modal = document.getElementById("delete-inloop-modal")
  if (!modal) {
    console.error("Modal not found!")
    return
  }

  const nameElement = modal.querySelector('[data-delete-modal-target="inloopName"]')
  const formElement = modal.querySelector('[data-delete-modal-target="form"]')

  if (nameElement) {
    nameElement.textContent = inloopName
  }

  if (formElement) {
    formElement.action = `/facilitator/inloops/${inloopId}`
  }

  modal.classList.remove("hidden")
  document.body.style.overflow = "hidden"
}

// Make it globally available
window.openDeleteModal = openDeleteModal
